import React, { useState } from 'react';
import { Plus, Infinity } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

interface CreateLinkDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (targetId: string, oneTime: boolean) => void;
  type: 'add' | 'info';
}

export function CreateLinkDialog({
  open,
  onClose,
  onSubmit,
  type,
}: CreateLinkDialogProps) {
  const [oneTime, setOneTime] = useState(type === 'add');

  const handleSubmit = () => {
    // Use a fixed target ID since we don't need parent selection anymore
    onSubmit('default', oneTime);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {type === 'add' ? 'إنشاء رابط إضافة مولود' : 'إنشاء رابط من أنت'}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Label htmlFor="oneTime" className="flex items-center gap-2">
              رابط لمرة واحدة
              {!oneTime && <Infinity className="h-4 w-4 text-primary" />}
            </Label>
            <Switch
              id="oneTime"
              checked={oneTime}
              onCheckedChange={setOneTime}
            />
          </div>
          <p className="text-sm text-gray-500">
            {oneTime 
              ? 'سيتم تعطيل الرابط تلقائياً بعد أول استخدام'
              : 'سيظل الرابط نشطاً حتى يتم تعطيله يدوياً'}
          </p>
        </div>
        <DialogFooter className="flex justify-start gap-2">
          <Button
            onClick={handleSubmit}
            className="hover:bg-secondary"
          >
            <Plus className="h-4 w-4 ml-2" />
            إنشاء
          </Button>
          <Button
            variant="ghost"
            onClick={onClose}
          >
            إلغاء
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}